import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'



export const ACCESS_TOKEN_KEY = 'access_token'
export const REFRESH_TOKEN_KEY = 'refresh_token'

const safeGet = (key) => {
    try {
        return localStorage.getItem(key) || ''
    } catch (e) {
        return ''
    }
}

const safeSet = (key, value) => {
    try {
        if (value) {
            localStorage.setItem(key, value)
        } else {
            localStorage.removeItem(key)
        }
    } catch (e) {
        /* private mode / storage disabled — the in-memory redux copy still works */
    }
}


export const getAccessToken = () => {
    try {
        const persisted = deepParseJson(localStorage.getItem(PERSIST_STORE_NAME))
        const fromStore = persisted?.auth?.session?.token
        if (fromStore) return fromStore
    } catch (e) {
        /* fall through to the raw key */
    }
    return safeGet(ACCESS_TOKEN_KEY)
}

export const setAccessToken = (token) => safeSet(ACCESS_TOKEN_KEY, token)

export const getRefreshToken = () => safeGet(REFRESH_TOKEN_KEY)

export const setRefreshToken = (token) => safeSet(REFRESH_TOKEN_KEY, token)


export const clearAuthTokens = () => {
    safeSet(ACCESS_TOKEN_KEY, null)
    safeSet(REFRESH_TOKEN_KEY, null)
    try {
        localStorage.removeItem('userDetails')
        localStorage.removeItem('login_time')
    } catch (e) {
        /* ignore */
    }
}
